import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    ViewChild,
    SimpleChanges,
    ChangeDetectionStrategy
} from '@angular/core';
import { YAxisTicksCustomComponent } from './y-axis-ticks.component';

@Component({
    selector: 'g[ngx-charts-y-axis-custom]',
    template: `
      <svg:g
        [attr.class]="yAxisClassName"
        [attr.transform]="transform">
        <svg:g ngx-charts-y-axis-ticks-custom
          *ngIf="yScale"
          [tickFormatting]="tickFormatting"
          [tickArguments]="tickArguments"
          [tickStroke]="tickStroke"
          [scale]="yScale"
          [hilightText]="hilightText"
          [scale2]="yScale2"
          [orient]="yOrient"
          [labelShow]="labelShow"
          [showGridLines]="showGridLines"
          [gridLineWidth]="dims.width"
          [referenceLines]="referenceLines"
          [showRefLines]="showRefLines"
          [showRefLabels]="showRefLabels"
          [height]="dims.height"
          (dimensionsChanged)="emitTicksWidth($event)"
        />
  
        <svg:g ngx-charts-axis-label
          *ngIf="showLabel"
          [label]="labelText"
          [offset]="labelOffset"
          [orient]="yOrient"
          [height]="dims.height"
          [width]="dims.width">
        </svg:g>
      </svg:g>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class YAxisCustomComponent implements OnChanges {

    @Input() yScale;
    @Input() hilightText;
    @Input() yScale2;
    @Input() dims;
    @Input() tickFormatting;
    @Input() showGridLines = false;
    @Input() labelShow:boolean = false;
    @Input() showLabel;
    @Input() labelText;
    @Input() yAxisTickInterval;
    @Input() yAxisTickCount: any;
    @Input() yOrient: string = 'left';
    @Input() referenceLines;
    @Input() showRefLines;
    @Input() showRefLabels;
    @Output() dimensionsChanged = new EventEmitter();

    yAxisClassName: string = 'y axis';
    tickArguments: any;
    offset: any;
    transform: any;
    yAxisOffset: number = -5;
    labelOffset: number = 15;
    fill: string = 'none';
    stroke: string = '#CCC';
    tickStroke: string = '#CCC';
    strokeWidth: number = 1;

    @ViewChild(YAxisTicksCustomComponent) ticksComponent: YAxisTicksCustomComponent;

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
        
    }

    update(): void {
        this.offset = this.yAxisOffset;
        if (this.yOrient === 'right') {
            this.labelOffset = 65;
            this.transform = `translate(${this.offset + this.dims.width} , 0)`;
        } else {
            this.transform = `translate(${this.offset} , 0)`;
        }

        if (this.yAxisTickCount !== undefined) {
            this.tickArguments = [this.yAxisTickCount];
        }
    }

    emitTicksWidth({ width }): void {
        if (width !== this.labelOffset && this.yOrient === 'right') {
            this.labelOffset = width + this.labelOffset;
            setTimeout(() => {
                this.dimensionsChanged.emit({ width });
            }, 0);
        } else if (width !== this.labelOffset) {
            this.labelOffset = width;
            setTimeout(() => {
                this.dimensionsChanged.emit({ width });
            }, 0);
        }
    }

}
